import axios from 'axios';

export const axiosInstance = axios.create({
  headers: {
    'x-api-key': `${process.env.NEXT_PUBLIC_RESERVE_APIKEY}`,
  },
});

export const axiosServiceAceInstance = axios.create({
  timeout: 60000,
});

export const axiosFetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);
